import React from "react";
import { Box } from "@chakra-ui/react";

// Filters
import FilterForm from "../../../components/FilterForm";

import DailyOrganizationTickets from "../../organization/daily/DailyOrganizationTickets";
import DailyOrganizationTicketsPerBranch from "../../organization/daily/DailyOrganizationTicketsPerBranch";
import DailyOrganizationTicketsPerService from "../../organization/daily/DailyOrganizationTicketsPerService";
import DailyOrganizationWaitingTime from "../../organization/daily/DailyOrganizationWaitingTime";
import DailyOrganizationWaitingTimePerService from "../../organization/daily/DailyOrganizationWaitingTimePerService";
import DailyBranchTicketsPerService from "../../branches/daily/DailyBranchTicketsPerService";
import DailyBranchServiceTimePerService from "../../branches/daily/DailyBranchServiceTimePerService";
import DailyBranchWaitingTimePerService from "../../branches/daily/DailyBranchWaitingTimePerService";
import { Helmet } from "react-helmet";

const DailyFullReportTicketManagement = () => {
  const report = [
    <DailyOrganizationTickets />,
    <DailyOrganizationTicketsPerService />,
    <DailyOrganizationTicketsPerBranch />,
    <DailyOrganizationWaitingTime />,
    <DailyOrganizationWaitingTimePerService />,
    <DailyBranchTicketsPerService />,
    <DailyBranchServiceTimePerService />,
    <DailyBranchWaitingTimePerService />,
  ];
  return (
    <Box>
      <Helmet>
        <title>Ticket Management Daily Full Report</title>
      </Helmet>
      <FilterForm />
      {report.map((a, index) =>
        React.cloneElement(a, {
          key: index,
          
          showFilterForm: 0,
          showTitle: 0,
        })
      )}
    </Box>
  );
};

export default DailyFullReportTicketManagement;
